import { Address } from './address.model';

export class Contact {
  firstName: string;
  lastName: string;
  emailAddress?: string;
  phoneNumber?: string;
  address?: Address;
}
